import script from "./JoinCommunity.vue?vue&type=script&setup=true&lang=ts"
export * from "./JoinCommunity.vue?vue&type=script&setup=true&lang=ts"

import "./JoinCommunity.vue?vue&type=style&index=0&id=2ef96246&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef96246"]])

export default __exports__